// extracted by mini-css-extract-plugin
export default {"actionPopUpButtons":"CartActionPopUpV2_actionPopUpButtons__QfO-K","btnSecondary":"CartActionPopUpV2_btnSecondary__mt0fm","btnPrimary":"CartActionPopUpV2_btnPrimary__34Yqv"};